import clsx from 'clsx';
import { useFormik } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DrawerSkeleton from '../..';
import CommonCard from '../../../Components/General/CommonCard';
import DefineTime from '../../../Components/General/DefineTime';
import LabeledText from '../../../Components/General/LabeledText';
import ServicesAction from '../../../Components/General/ServicesAction';
import Button from '../../../Components/UI/Button';
import DateSelector from '../../../Components/UI/DateSelector';
import TimeSelectorCard from '../../../Components/UI/TimeSelectorCard';
import useAppointment from '../../../Features/useAppointment';
import { formatPhoneNumber, todayTimeRange } from '../../../Helpers';
import { createAppointmentSchema } from '../../../Schema';
import { setSelectedService } from '../../../Store/serviceSlice';
import DrawerHeader from '../../DrawerHeader';
import CreatePatientDrawer from '../../PatientDrawer/CreatePatientDrawer';
import RescheduleAppointmentDrawer from '../../TodayAppointmentDrawer/RescheduleAppointment';
import CreateAndViewServicesDrawer from '../../TodayAppointmentDrawer/RescheduleAppointment/CreateAndViewServicesDrawer';
import classes from './CreateAppointmentDetailDrawer.module.css';
import UpcomingAppointmentAccordion from './UpcomingAppointmentAccordion';
const initialValues = {
  appointmentStartDate: '',
  appointmentStartTime: '',
  isOpd: true
};
const CreateAppointmentDetailDrawer = ({
  show,
  setShow,
  data,
  setShow2,
  selectedDate,
  onClearPrev,
  createPatient = false
}) => {
  const {
    addAppointment,
    getAppointmentSlots,
    registerAndAddAppointment,
    getAllAppointments,
    respectiveSlots,
    slotsIndicator,
    loading,
    setSlotsIndicator
  } = useAppointment();

  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);
  const [showCreatePatientDrawer, setSetShowCreatePatientDrawer] = useState(false);
  const [showServicesDrawer, setShowServicesDrawer] = useState(false);
  const [showRescheduleDrawer, setShowRescheduleDrawer] = useState(false);
  const [upcomingAppointmentData, setupComingAppointmentData] = useState(null);
  const dispatch = useDispatch();
  const toggleCreatePatientDrawer = () => {
    setSetShowCreatePatientDrawer((currentState) => !currentState);
    setShow();
  };
  const toggleCreateAndViewServicesDrawer = () => {
    setShowServicesDrawer((prev) => !prev);
  };
  const toggleRescheduleAppointment = () => {
    setShowRescheduleDrawer((prev) => !prev);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: createAppointmentSchema,
    onSubmit: (values, { resetForm }) => {
      const servicesTaken = selectedServices?.flatMap((item) =>
        Array(item?.quantity).fill(item?.serviceId)
      );
      const params = {
        ...values,
        patientId: data?.patientId,
        appointmentStartDateTime: moment(
          `${moment(values?.appointmentStartDate).format('YYYY-MM-DD')} ${
            values?.appointmentStartTime?.timeFrom
          }`,
          'YYYY-MM-DD hh:mm A'
        )
          .utc()
          .toISOString(),

        appointmentEndDateTime: moment(
          `${moment(values?.appointmentStartDate).format('YYYY-MM-DD')} ${
            values?.appointmentStartTime?.timeTo
          }`,
          'YYYY-MM-DD hh:mm A'
        )
          .utc()
          .toISOString(),
        isOpd: true,
        ...(data && { patientId: data?.id ? data?.id : data?.patientId }),
        appliedFees: values?.appliedFees
          ?.map((data) => data?.serviceId)
          .filter((data) => data != null)
      };
      delete params?.appointmentStartTime;
      delete params?.appointmentStartDate;

      if (createPatient) {
        const createPatientAndAppointmentParams = {
          ...data,
          appointmentStartDateTime: moment(
            `${moment(values?.appointmentStartDate).format('YYYY-MM-DD')} ${
              values?.appointmentStartTime?.timeFrom
            }`,
            'YYYY-MM-DD hh:mm A'
          )
            .utc()
            .toISOString(),
          // appointmentStartDateTime: st,
          appointmentEndDateTime: moment(
            `${moment(values?.appointmentStartDate).format('YYYY-MM-DD')} ${
              values?.appointmentStartTime?.timeTo
            }`,
            'YYYY-MM-DD hh:mm A'
          )
            .utc()
            .toISOString(),
          isOpd: servicesTaken?.length > 0
        };
        //here create patient and appointment
        registerAndAddAppointment(createPatientAndAppointmentParams, () => {
          dispatch(setSelectedService([]));
          resetForm();
          setShow();
          onClearPrev();
          getAllAppointments(todayTimeRange());
        });
      } else {
        addAppointment(params, () => {
          resetForm();
          setShow();
          dispatch(setSelectedService([]));
        });
      }
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  useEffect(() => {
    if (values?.appointmentStartDate) {
      getAppointmentSlots({
        date: moment(new Date(values?.appointmentStartDate)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        timeZone: 'Asia/Karachi'
      });
      setValues({ ...values, appointmentStartTime: null });
    }
  }, [values?.appointmentStartDate]);

  const onCancel = () => {
    setSlotsIndicator('');
    resetForm();
  };
  useEffect(() => {}, [show]);
  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          setShow();
          onCancel();
          dispatch(setSelectedService([]));
          if (typeof onClearPrev === 'function') {
            onClearPrev();
          }
          resetForm({ values: { ...initialValues } });
        }}>
        <DrawerHeader
          title={'Create Appointment'}
          show={show}
          onClose={() => {
            if (typeof onClearPrev === 'function') onClearPrev();
          }}
          setShow2={() => {
            setShow2();
          }}
          setShow={() => {
            setShow();
            onCancel();
            dispatch(setSelectedService([]));
          }}
        />
        <form onSubmit={handleSubmit} className={clsx(classes.formWrapper, 'scrollbar1')}>
          <section>
            <CommonCard>
              <h2 className={classes.cardHeading}>{data?.patientName}</h2>
              <div className={classes.shortDetail}>
                <LabeledText
                  label={'Phone Number'}
                  value={formatPhoneNumber(data?.countryCode + data?.cellNumber)}
                />
                <LabeledText
                  label={'Age/Gender'}
                  value={`${data?.age} , ${
                    typeof data?.gender === 'object' ? data?.gender?.label : data?.gender
                  } `}
                />
              </div>
            </CommonCard>
            <Row className={clsx(classes.slotsSelectorWrapper, 'mx-0')}>
              <Col sm={6} className={clsx('ps-sm-0', classes.col)} xs={12}>
                <DateSelector
                  className={classes.control}
                  setter={(e) => {
                    handleChangeWithTouch('appointmentStartDate', e);
                  }}
                  minDate={new Date()}
                  value={values?.appointmentStartDate}
                  allowFutureDates={false} // Enable selecting future dates
                  placeholder="MM/dd/yyyy"
                  dateFormat="MM/dd/yyyy"
                  startYear={1950}
                  endYear={9999} // Infinite years
                  showYearDropdown={true}
                  scrollableYearDropdown={true}
                  errorText={touched.appointmentStartDate && errors?.appointmentStartDate}
                />
              </Col>
              <Col sm={6} className={clsx('pe-sm-0 mt-sm-0 mt-3', classes.col)} xs={12}>
                <TimeSelectorCard
                  loading={loading}
                  slotsIndicator={slotsIndicator}
                  slots={respectiveSlots}
                  value={values?.appointmentStartTime}
                  clickAreaAll={true}
                  setter={(e) => {
                    handleChangeWithTouch('appointmentStartTime', e);
                  }}
                  disabled={values?.appointmentStartDate}
                  errorText={touched.appointmentStartTime && errors?.appointmentStartTime}
                />
                {/* <TimeSelector
                  className={classes.control}
                  value={values?.appointmentStartTime}
                  setter={(e) => {
                    handleChangeWithTouch('appointmentStartTime', e);
                  }}
                  errorText={touched.appointmentStartTime && errors?.appointmentStartTime}
                /> */}
              </Col>
            </Row>
            <div>{slotsIndicator && <DefineTime show={show} />}</div>
            {data?.upcomingAppointment?.length > 0 && (
              <div className={classes.appointmentsWrapper}>
                <UpcomingAppointmentAccordion
                  show={show}
                  data={data?.upcomingAppointment}
                  setter={(e) => {
                    setupComingAppointmentData(e);
                    toggleRescheduleAppointment();
                    setShow();
                  }}
                />
              </div>
            )}
            <div className={classes.serviceWrapper}>
              <ServicesAction
                show={show}
                isDrawerOpen={show}
                onClick={() => {
                  toggleCreateAndViewServicesDrawer();
                  setShow();
                }}
              />
            </div>
          </section>
          <div className={classes.bottomAction}>
            <Button
              label={'Close'}
              variants="secondary"
              onClick={() => {
                resetForm({ values: { ...initialValues } });
                // resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                if (typeof onClearPrev === 'function') onClearPrev();
                onCancel();
                dispatch(setSelectedService([]));
                setShow(); // Close the drawer
              }}
            />
            <Button
              type="submit"
              label={`Add Appointment`}
              disabled={!(isValid && dirty && selectedServices?.length > 0) || loading} // Enable if valid and either dirty or data is loaded
            />
          </div>
        </form>
      </DrawerSkeleton>
      <CreateAndViewServicesDrawer
        resetOfPrevDrawer={resetForm}
        setShow2={() => {
          setShow();
        }}
        setShow={toggleCreateAndViewServicesDrawer}
        show={showServicesDrawer}
      />
      <CreatePatientDrawer show={showCreatePatientDrawer} setShow={toggleCreatePatientDrawer} />
      <RescheduleAppointmentDrawer
        show={showRescheduleDrawer}
        setShow={toggleRescheduleAppointment}
        setShow2={setShow}
        data={{
          patientName: data?.patientName,
          countryCode: data?.countryCode,
          cellNumber: data?.cellNumber,
          gender: data?.gender,
          age: data?.age,
          ...upcomingAppointmentData
        }}
      />
    </>
  );
};

export default CreateAppointmentDetailDrawer;
